import { createContext, useContext, useMemo, useState } from 'react'
import type { Dispatch, ReactNode, SetStateAction } from 'react'
import type { WidgetType } from 'types/widget'

type WidgetState = {
  type: WidgetType
  origin: string
}

type WidgetContextValues = {
  values: WidgetState | undefined
  isWidget: boolean
  setWidget: Dispatch<SetStateAction<WidgetState | undefined>>
}

const DEFAULT_VALUES: WidgetContextValues = {
  values: undefined,
  isWidget: false,
  setWidget: () => {},
}

const Context = createContext<WidgetContextValues>(DEFAULT_VALUES)

export function WidgetProvider({ children }: { children: ReactNode }) {
  const [widget, setWidget] = useState<WidgetState | undefined>(undefined)

  const values: WidgetContextValues = useMemo(
    () => ({ values: widget, setWidget, isWidget: !!widget }),
    [widget],
  )

  return <Context.Provider value={values}>{children}</Context.Provider>
}

export function useWidget() {
  return useContext(Context)
}
